export const GET_EMPLOYEE_FOR_LOBBYIST = "GET_EMPLOYEE_FOR_LOBBYIST"
export const GET_EMPLOYEES_FOR_LOBBYIST_BY_DATE = "GET_EMPLOYEES_FOR_LOBBYIST_BY_DATE"
export const GET_EMPLOYEE = "GET_EMPLOYEE"
export const UPDATE_EMPLOYEE_FOR_LOBBYIST = "UPDATE_EMPLOYEE_FOR_LOBBYIST"
export const ADD_EMPLOYEE_TO_LOBBYIST = "ADD_EMPLOYEE_TO_LOBBYIST"
export const REMOVE_EMPLOYEE_FROM_LOBBYIST = "REMOVE_EMPLOYEE_FROM_LOBBYIST"
export const CLEAR_EMPLOYEE = "CLEAR_EMPLOYEE"
export const CLEAR_EMPLOYEES_FOR_LOBBYIST = "CLEAR_EMPLOYEES_FOR_LOBBYIST"


// WEBPACK FOOTER //
// ./src/actionTypes/employee.js